import { useEffect } from "react";

const setMeta = (name, content, attr = "name") => {
    if (!content) return;
    let el = document.querySelector(`meta[${attr}="${name}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
};

const setCanonical = (href) => {
    if (!href) return;
    let el = document.querySelector('link[rel="canonical"]');
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", "canonical");
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
};

const JSONLD_ID = "ucs-page-jsonld";

const setJsonLd = (data) => {
    // Verwijder vorige page-specifieke schema (statisch AutoDealer schema in index.html
    // blijft staan want die heeft geen id)
    const prev = document.getElementById(JSONLD_ID);
    if (prev) prev.remove();
    if (!data) return;
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = JSONLD_ID;
    script.text = JSON.stringify(data);
    document.head.appendChild(script);
};

export const SEO = ({ title, description, image, path, jsonLd }) => {
    useEffect(() => {
        const fullTitle = title ? `${title} · Used Car Selection` : "Used Car Selection · Occasions in Bornem";
        document.title = fullTitle;

        const desc = description || "Geselecteerde tweedehands wagens met garantie. Showroom Bornem, België — bekijk ons aanbod, plan een proefrit of verkoop uw wagen.";
        setMeta("description", desc);

        const url = `${window.location.origin}${path ?? window.location.pathname}`;
        setCanonical(url);

        // Open Graph
        setMeta("og:title", fullTitle, "property");
        setMeta("og:description", desc, "property");
        setMeta("og:type", "website", "property");
        setMeta("og:url", url, "property");
        setMeta("og:site_name", "Used Car Selection", "property");
        if (image) setMeta("og:image", image, "property");

        // Twitter
        setMeta("twitter:card", "summary_large_image");
        setMeta("twitter:title", fullTitle);
        setMeta("twitter:description", desc);
        if (image) setMeta("twitter:image", image);

        // JSON-LD per pagina (Vehicle/Product/etc.)
        setJsonLd(jsonLd);
        return () => setJsonLd(null);
    }, [title, description, image, path, jsonLd]);

    return null;
};
